import {
    Text,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    useColorModeValue
} from '@chakra-ui/react'

import theme from '../../../Config/theme'

const FaqItem = ({ question, answer }) => {
    const backgroundColor = useColorModeValue('gray.100', 'gray.800')
    const borderColor = useColorModeValue(theme.borderColor.borderColorLight, theme.borderColor.borderColorDark)
    
    return (
        <AccordionItem 
        borderRadius={'lg'}
        bgColor={backgroundColor}
        mb={4} 
        border={'1px'}
        borderColor={borderColor}
        >
            <AccordionButton _expanded={{ backgroundColor: '#0D9494', color: 'white' }} borderTopRightRadius={'lg'} borderTopLeftRadius={'lg'} _hover={{}}>
                <Box flex={'1'} textAlign={'left'}>
                    {question}
                </Box>
                <AccordionIcon />
            </AccordionButton>
            <AccordionPanel>
                <Text textAlign={'start'}>{answer}</Text>
            </AccordionPanel>
        </AccordionItem>
    )
}

export default FaqItem